export default __webpack_public_path__ + "static/media/schedule.cce0f6a2.svg";